import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Api from "../api/Api";
import { Badge, Container } from "react-bootstrap";
import TimeAgo from "../timeAgo/TimeAgo";
import { Link } from "react-router-dom";

const NotificationItem = () => {
  const { id } = useParams(); // Extracting notification ID from URL
  const [notification, setNotification] = useState(null);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const getSingleNotficationId = Api({
    url: `notify/id/${id}`,
  });
  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const response = await getSingleNotficationId.fetchData();
        setNotification(response?.data?.notification);
      } catch (error) {
        console.error("Error fetching notification:", error);
      }
    };

    fetchNotification();
  }, [id]);

  return (
    <div>
      {notification ? (

<Container className="notification-detail-page py-5">
  <div className="notif-detail-wrapper bg-white shadow-sm rounded-3 p-4 mx-auto">
    {/* Page Header */}
    <div className="mb-4 border-bottom pb-2 d-flex flex-wrap justify-content-between align-items-center gap-2">
      <h5 className="mb-0 d-flex align-items-center gap-2">
        <span role="img" aria-label="bell">🔔</span> Notification Details
      </h5>

    </div>

    {/* Header Title & Status */}
    <div className="row align-items-start mb-3">
      <div className="col-12 col-md-8">
        <h4 className="mb-1 text-primary">{notification?.notification_title}</h4>
        <div className="d-flex flex-wrap align-items-center gap-2">
          <Badge bg="info" className="text-uppercase small">
            {notification?.notification_for}
          </Badge>
          <Badge
            bg={notification?.is_read ? "success" : "warning"}
            text={notification?.is_read ? "light" : "dark"}
            className="small"
          >
            {notification?.is_read ? "Read" : "Unread"}
          </Badge>
        </div>
      </div>

      {/* Time */}
      <div className="col-12 col-md-4 text-md-end text-muted small mt-3 mt-md-0">
        <TimeAgo timestamp={notification?.created_on} />
      </div>
    </div>

    {/* Body Text */}
    <p className="mt-3 mb-4" style={{ fontSize: "1rem", color: "#444" }}>
      {notification?.notification_text}
    </p>

    <hr className="my-4" />

    {/* Meta Footer */}
    <div className="d-flex align-items-center gap-3 text-muted small flex-wrap">
      <div
        className="notif-avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
        style={{ width: 40, height: 40 }}
      >
        {notification?.user_name?.charAt(0)}
      </div>
      <div>
        <div>
          <strong>{notification?.user_name}</strong> ({notification?.user_type})
        </div>
      </div>
    </div>
  </div>

  {/* Bottom Back Button */}
  <div className="text-center mt-4">
    <Link to="/notification" className="btn btn-outline-secondary">
      Back
    </Link>
  </div>
</Container>



      ) : (
        <p>Loading...</p>
      )}


    </div>
  );
};

export default NotificationItem;
